<template>
    <div class="team-suspended-alert rounded-none bg-amber-100 px-5 py-3 flex items-center gap-3 w-full">
        <div class="text-amber-500">
            <font-awesome-icon widthAuto :icon="faTriangleExclamation" />
        </div>
        <div class="text-sm">
            This account (<strong>{{ teamName }}</strong>) is suspended. Please contact support.
        </div>
    </div>
</template>

<script setup>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faTriangleExclamation } from '@fortawesome/pro-solid-svg-icons';

const teamName = Spark.state.currentTeam.name;
</script>
